<template>
  <v-card
    class="mx-auto bc-extra-light-gray b-1 mt-16 pa-8"
    max-width="700px"
  >
    <v-card-text class="ta-center">
      <img
        alt=""
        class="mb-4"
        src="/icons/login_check.svg"
      />
      <v-row class="fs-32 fw-800 mb-8">
        <v-col>
          <span>
            {{ $bct('Welcome back!') }}
          </span>
        </v-col>
      </v-row>
      <v-btn
        @click="check()"
        :loading="processing"
        color="primary"
        data-testid="continue-button"
        size="x-large"
      >
        {{ $bct('Continue') }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script setup>
import _ from 'lodash';
import useApi from '@/shared/composables/useApi';
import useEventBus from '@/shared/composables/useEventBus';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

const { api: Api } = useApi();
const display = ref(true);
const eventBus = useEventBus();
const processing = ref(false);
const route = useRoute();
const router = useRouter();
const store = useStore();
const $bct = inject('translator');

onMounted(() => {
  if (!_.isEmpty(route.query.redirect_url)) {
    check();
  } else {
    store.dispatch('identify', {
      success() {
        // If user is unauthenticated, go through Login Code flow
        if (store.state.profile.is_anonymous) {
          check();
        } else {
          routeToDestination();
        }
      },
      failure() {
        // If SSO is enabled and a user is replying an email hard-coded to Login Codes, redirect to SSO
        // We allow BridgeCare Admin to manually produce login codes otherwise
        if (
          store.state.site.sso_connections &&
          store.state.site.sso_connections.length > 0 &&
          route.query.destination === 'messages'
        ) {
          router.push({ name: 'Signup', query: { mode: 'login', ...route.query } });
          return;
        }

        load();
      },
    });
  }
});

function check() {
  processing.value = true;
  Api.member.session.create(
    { login_code: route.params.login_code },
    () => {
      store.dispatch('identify', {
        success() {
          routeToDestination();
        },
        failure() {
          error();
          processing.value = false;
        },
      });
    },
    error,
  );
}

function error() {
  eventBus.chime('Login link is expired or incorrect. Please try again.');
  router.push({ name: 'Landing' });
}

function load() {
  display.value = true;
}

function routeToDestination() {
  if (route.query.redirect_url) {
    router.push(route.query.redirect_url);
    return;
  }
  if (route.query.destination === 'messages') {
    router.push({ name: 'MessageIndex' });
  } else if (route.query.destination === 'tour') {
    router.push({
      name: 'TourShow',
      params: { tourId: route.query.tour_id },
      query: { action: 'confirm' },
    });
  } else if (route.query.destination === 'provider') {
    router.push({ name: 'PublicProviderShow', params: { providerId: route.query.provider_id } });
  } else if (route.query.destination === 'documents') {
    router.push({ name: 'DocumentIndex' });
  } else if (route.query.destination === 'forms') {
    router.push({ name: 'FormIndex' });
  } else if (route.query.destination === 'grants') {
    router.push({ name: 'GrantIndex' });
  } else {
    router.push({ name: 'Dashboard' });
  }
}
</script>
